import { AppPanel } from 'recycle-race-common/lib/enums'
const panels = Object.keys(AppPanel).reduce(
	(acc, key) => ({
		...acc,
		[key]: null,
	}),
	{}
)

export const competitionForm = () => ({
	enabled: true,
	name: '',
	dates: {
		from: null,
		to: null,
	},
	entryForm: {
		name: true,
		email: true,
		age: false,
		mobile: false,
		postcode: false,
		address: false,
		schemeId: false,
	},
	prizes: [],
	leaderboards: [],
	panels,
	linkTerms: '',
	linkPrivacy: '',
})
